import { Currency } from '@/core/currency/interfaces';

const HRK: Currency = {
    name: 'Croatian Kuna',
    demonym: 'Croatian',
    majorSingle: 'Kuna',
    majorPlural: 'Kuna',
    codeNumeric: '191',
    symbol: 'kn',
    symbolNative: 'kn',
    minorSingle: 'Lipa',
    minorPlural: 'Lipa',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'HRK',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default HRK;
